import { render, staticRenderFns } from "./ManageUsersGroupsCreate.vue?vue&type=template&id=0819853a&scoped=true"
import script from "./ManageUsersGroupsCreate.vue?vue&type=script&lang=js"
export * from "./ManageUsersGroupsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0819853a",
  null
  
)

export default component.exports